import styled from 'styled-components'

import ProductsFilters from '../ProductsFilters'
import FormFieldSelect from '../../form/fields/FormFieldSelect'
import ActionButton from '../ActionButton'
import { mq, sizes } from '../../theme'
import BoxedContainer from '../BoxedContainer'

export const Wrapper = styled.div``

export const Filters = styled(ProductsFilters)``
export const SelectField = styled(FormFieldSelect)`
  max-width: 30rem;
  width: 100%;

  @media ${mq(null, sizes.tablet)} {
    max-width: 100%;
  }
`
export const FilterButton = styled(ActionButton)``

export const Top = styled(BoxedContainer)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 4rem auto;

  @media ${mq(null, sizes.tablet)} {
    flex-direction: column;
  }
`

export const SearchText = styled.p`
  ${({ theme }) => theme.textStyles.firaSans3Xl};
  color: ${({ theme }) => theme.colors.bluePrimary};

  @media ${mq(null, sizes.tablet)} {
    ${({ theme }) => theme.textStyles.firaSansXl};
  }
`
export const SearchResults = styled.p`
  ${({ theme }) => theme.textStyles.vujahdayLarge};
  color: ${({ theme }) => theme.colors.bluePrimary};
  font-style: italic;
`

export const Search = styled.div`
  display: flex;
  align-items: center;
  gap: 3rem;
  width: 100%;
`
export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1.7rem;
  width: 100%;
  margin-top: 1.8rem;
`
